import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Dialisis from "./components/Servicios/Dialisis/Dialisis";
import Radioterapia from "./components/Servicios/Radioterapia/Radioterapia";
import Quimioterapia from "./components/Servicios/Quimioterapia/Quimioterapia";
import Mutuas from "./components/Servicios/Mutuas/Mutuas";

import Login from "./components/Login/Login";
import ServiciosSolicitados from "./components/ServiciosSolicitados";
import { QueryClientProvider, QueryClient } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import Home from "./components/Home";
import Quejas from "./components/Quejas";
import Splash from "./Splash";
import AcercaDe from "./components/AcercaDe";
import Pacientes from "./components/Pacientes";
import { BASE_URL } from "./utils/index";
import { postJson } from "./utils/postJson";
import { Redirect } from "react-router-dom";

const queryClient = new QueryClient();
const CLAVE_ERROR_AUTORIZACION =
  "Authorization...you do not have permission to see this data";

function clearClientSession() {
  ["idCliente", "email", "password", "accessToken", "csrfToken", "perfil"].forEach(
    (key) => localStorage.removeItem(key)
  );
  sessionStorage.removeItem("accessToken");
}

function App() {
  const [isLogged, setLogged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [sessionError, setSessionError] = useState("");
  const [contexto, setContexto] = useState({ tipoCliente: "", clientes: [], serviciosPermitidos: [] });

  useEffect(() => {
    const fetchData = async () => {
      const email = localStorage.getItem("email");
      const rememberedToken =
        localStorage.getItem("accessToken") || localStorage.getItem("csrfToken");
      const sessionToken = sessionStorage.getItem("accessToken");
      const accessToken = rememberedToken || sessionToken;
      const idCliente = localStorage.getItem("idCliente");
      if (rememberedToken) {
        localStorage.setItem("accessToken", rememberedToken);
        sessionStorage.removeItem("accessToken");
      }
      localStorage.removeItem("csrfToken");
      localStorage.removeItem("password");

      if (!email || !accessToken || !idCliente) {
        clearClientSession();
        setLoading(false);
        return;
      }

      try {
        const responseServer = await postJson(`${BASE_URL}/home`, {
          idCliente,
        }, {
          showLoading: window.location.pathname === "/",
        });

        if (responseServer?.message !== "Success!") {
          setSessionError("No se pudo comprobar la sesión. Comprueba la conexión e inténtalo de nuevo.");
        } else {
          setContexto({ tipoCliente: responseServer.tipoCliente, clientes: responseServer.clientes || [], serviciosPermitidos: responseServer.serviciosPermitidos || [] });
          setLogged(true);
        }
      } catch (error) {
        if (error.status === 401 || error.message === CLAVE_ERROR_AUTORIZACION) {
          clearClientSession();
          setSessionError("La sesión ha caducado. Vuelve a iniciar sesión.");
        } else {
          setSessionError(
            error.message === "No se pudo conectar con el servidor."
              ? "No se pudo conectar con el servidor. Comprueba la conexión e inténtalo de nuevo."
              : "No se pudo comprobar la sesión. Comprueba la conexión e inténtalo de nuevo."
          );
        }
      } finally {
        setLoading(false);
      }
    };

    const handleSessionExpired = () => {
      clearClientSession();
      queryClient.clear();
      setSessionError("La sesión ha caducado. Vuelve a iniciar sesión.");
      setLogged(false);
    };

    window.addEventListener("client-session-expired", handleSessionExpired);
    fetchData();

    return () => window.removeEventListener("client-session-expired", handleSessionExpired);
  }, []);
  if (loading) {
    return <Splash />;
  }

  if (!isLogged) {
    return <Login sessionError={sessionError} />;
  } else {
    return (
      <QueryClientProvider client={queryClient}>
        {process.env.NODE_ENV === "development" && (
          <ReactQueryDevtools
            initialIsOpen={false}
            position="top-right"
            toggleButtonProps={{ style: { bottom: "auto" } }}
          />
        )}
        <BrowserRouter>
          <Dashboard contexto={contexto} />
          <Switch>
            <Route path="/" exact={true}>
              <Home />
            </Route>
            <Route path="/dialisis">
              {contexto.serviciosPermitidos.includes("dialisis") ? <Dialisis /> : <Redirect to="/" />}
            </Route>
            <Route path="/radioterapia">
              {contexto.serviciosPermitidos.includes("radioterapia") ? <Radioterapia /> : <Redirect to="/" />}
            </Route>
            <Route path="/quimioterapia">
              {contexto.serviciosPermitidos.includes("quimioterapia") ? <Quimioterapia /> : <Redirect to="/" />}
            </Route>
            <Route path="/mutuas">
              {contexto.serviciosPermitidos.includes("mutuas") ? <Mutuas /> : <Redirect to="/" />}
            </Route>
            <Route path="/pacientes"><Pacientes contexto={contexto} /></Route>
            {/* <Route path="/servicio-taxi">
              <Lleida />
            </Route>
            <Route path="/viaje-barcelona">
              <Barcelona />
            </Route> */}
            <Route path="/servicios-solicitados">
              <ServiciosSolicitados />
            </Route>
            <Route path="/viajes-solicitados">
              <Redirect to="/servicios-solicitados" />
            </Route>
            <Route path="/quejas">
              <Quejas />
            </Route>
            <Route path="/acerca-de">
              <AcercaDe />
            </Route>
            <Redirect to="/" />
          </Switch>
        </BrowserRouter>
      </QueryClientProvider>
    );
  }
}

export default App;
